import React, { FC } from 'react';
import cls from 'classnames';

import { IWebLink } from '../../../../../../types';
import LinksComponent from '../../../../../../molecules/Links';

import styles from './index.module.sass';

interface LinksProps {
  data?: IWebLink[];
  overlay: boolean;
}

const Links: FC<LinksProps> = ({ data, overlay }) => (
  <LinksComponent
    className={{
      container: cls( styles.container, {
        [styles.overlay]: overlay,
      }),
      link: cls( styles.link, { [styles.visible]: overlay }),
    }}
    data={data}
  />
);

export default Links;
